export default "<div class=\"container-fluid\">\n    <div class=\"container\">\n       \n    </div>\n</div>"